import { render, staticRenderFns } from "./referee-list.vue?vue&type=template&id=c673cb6c&scoped=true&"
import script from "./referee-list.vue?vue&type=script&lang=js&"
export * from "./referee-list.vue?vue&type=script&lang=js&"
import style0 from "./referee-list.vue?vue&type=style&index=0&id=c673cb6c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c673cb6c",
  null
  
)

export default component.exports